/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core';
import OverviewTickets from '../../modules/apps/support/OverviewTickets';
import Tickets from '../../modules/apps/support/Tickets';
import FAQ from '../../modules/apps/support/FAQ';
import ContactUs from '../../modules/apps/support/ContactUs';
import EngageWidgetSupport from '../../../_metronic/partials/widgets/_new/engage/EngageWidgetSupport';

export enum tabs {
  'overview' = 'overview',
  'tickets' = 'tickets',
  'faq' = 'faq',
  'contactUs' = 'contactUs'
}

// Coming Soon banner — used for Overview and Tickets while those features are hidden
const ComingSoonBanner: FC = () => {
  const intl = useIntl()
  return (
    <div className='card'>
      <div className='card-body d-flex flex-column align-items-center justify-content-center py-20'>
        <div className='mb-5'>
          <i className='ki-duotone ki-time fs-5tx text-primary'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
        </div>
        <h1 className='fw-bold text-dark mb-3'>{intl.formatMessage({ id: 'COMMON.MESSAGES.COMING_SOON' })}</h1>
        <p className='text-muted fs-5 text-center mb-0'>
          {intl.formatMessage({ id: 'COMMON.MESSAGES.COMING_SOON_DESC' })}
        </p>
      </div>
    </div>
  )
}

const SupportCenter: FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // Default tab changed to faq — Overview and Tickets are hidden temporarily
  const defaultTab = params.get('tab') as tabs || tabs.faq;
  const [tab, setTab] = useState(defaultTab);

  let [tabComponent, setTabComponent] = useState(<FAQ />);

  useEffect(() => {
    switch (tab) {
      case tabs.overview:
        // Hidden temporarily — showing Coming Soon instead of <OverviewTickets />
        setTabComponent(<ComingSoonBanner />);
        break;
      case tabs.tickets:
        // Hidden temporarily — showing Coming Soon instead of <Tickets />
        setTabComponent(<ComingSoonBanner />);
        break;
      case tabs.faq:
        setTabComponent(<FAQ />);
        break;
      case tabs.contactUs:
        setTabComponent(<ContactUs />);
        break;
    }
  }, [tab])

  return (
    <>
      <EngageWidgetSupport tab={tab} setTab={setTab} />
      {tabComponent}
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const SupportCenterWrapper: FC = () => {
  const intl = useIntl()
  // const { setLayout } = useLayout();

  // useEffect(() => {
  //   setLayout("Support Center")
  // }, []);

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>{intl.formatMessage({ id: 'SUPPORT.PAGE_TITLE' })}</PageTitle>
      <SupportCenter />
    </>
  )
}

export { SupportCenterWrapper }